import { mergeWith, cloneDeep } from 'lodash-es';
import defaultSettings from '../../../settings.default';
import type { Settings } from './types';
import useSettingsStore from './index';
import { type RecursiveRequired } from '../../../@types/global';
import { getWujieOrQiankun } from '../../../utils/getWujieOrQiankun';

export const mergeSettings = (customSettings: Settings) => {
  customSettings.subApps?.forEach((config) => {
    const mount = config.onAfterMount;

    config.onAfterMount = () => {
      const settingsStore = useSettingsStore();
      getWujieOrQiankun().then(({ bus }) => {
        bus.$emit('theme', settingsStore.settings.theme.style); // TODO-主题色改变
      });
      mount?.();
    };
  });
  const newSettings = mergeWith(cloneDeep(defaultSettings), cloneDeep(customSettings), customizer) as RecursiveRequired<Settings>;
  if (newSettings.route.baseOn === 'filesystem') {
    // 文件系统路由时，由于文件系统路由会将2级以下的路由打平成一级路由，失去了层级关系，
    // 所以无法使用路由文件生成菜单模式和面包屑
    if (newSettings.menu.baseOn === 'routes') {
      newSettings.menu.baseOn = 'frontend';
    }

    // newSettings.layout.breadcrumb = false;
  }
  return newSettings;
};

// 数组合并（label 去重，srcValue 优先）
function mergeArrays(objArr: any[], srcArr: any[], uniqueKey: string): any[] {
  const map = new Map<string, any>();
  // 先合并 objValue 数组
  objArr?.forEach((item) => map.set(item[uniqueKey], item));
  // 再用 srcValue 覆盖
  srcArr?.forEach((item) => map.set(item[uniqueKey], item));
  return Array.from(map.values());
}

function customizer(objValue: any, srcValue: any, key: string) {
  if (key === 'personalCenter') {
    const objValueMap = objValue.reduce((acc: Record<string, any>, cur: any) => {
      acc[cur.id] = cur;
      return acc;
    }, {} as Record<string, any>);
    return srcValue.map((item: Record<string, any>) => ({ ...objValueMap[item.id], ...item }));
  } else if(key === 'toolboxConfig'){
    const mergedObject =  {...objValue,...srcValue };
    Object.keys(mergedObject).forEach((key) => {
      if (Array.isArray(mergedObject[key])) {
        mergedObject[key] = mergeArrays(objValue[key], srcValue[key], 'label')
      }
    });
    return mergedObject;
  }
}
